import { render, staticRenderFns } from "./comForm.vue?vue&type=template&id=42819553&scoped=true"
import script from "./comForm.vue?vue&type=script&lang=js"
export * from "./comForm.vue?vue&type=script&lang=js"
import style0 from "./comForm.vue?vue&type=style&index=0&id=42819553&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42819553",
  null
  
)

export default component.exports